import { backend, domain } from 'modules/data';

export function parseQBooksPayeeType(value: backend.IntegrationsQBooksPayeeType): domain.QBooksPayeeType {
    return {
        id: value.Value,
        text: value.Name,
    };
}
